export default __webpack_public_path__ + "static/media/25046-faq-ask-and-you-get-an-answer.317f99fe.gif";